import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Col, notification, Row, Skeleton } from 'antd';
import moment from 'moment';

import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../../../../actions/getAnalysisAction';
import { editCaseApi, editCaseReset } from '../../../../../actions/editCaseAction';
import { XForm } from '../../../../../styles/GlobalStyle';
import {
	XThemeForm,
	XThemeInputText,
	XThemeModal,
} from '../../../../../styles/GlobalThemeStyle';
import { XThemeVoiceAssTableCard } from '../../../VoiceAssistanceStyle';
import VATimelineLoader from './VATimelineLoader';
import VATimeline from './VATimeline';

const VACaseTimelineController = (props) => {
	const {
		actionParameters,
		setProcessingAction,
		getAnalysis,
		getAnalysisReset,
		editCase,
		editCaseReset,
	} = props;
	const [id, setId] = useState(null);
	const [patientData, setPatientData] = useState({});

	// Added state variables that might be referenced
	const [currentView, setCurrentView] = useState('skeleton');
	// Track whether analysis is in progress to prevent duplicate calls
	const [analysisInProgress, setAnalysisInProgress] = useState(false);

	// Parse case ID from action parameters
	useEffect(() => {
		if (actionParameters && actionParameters.case_id) {
			setId(actionParameters.case_id);
		}
	}, [actionParameters]);

	// Initial API call to get analysis
	useEffect(() => {}, [id]);

	// Render different views based on current state
	const renderComponent = () => {
		switch (currentView) {
			case 'skeleton':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							{/* <Skeleton active paragraph={{ rows: 6 }} /> */}
                            <VATimeline/>
						</div>
					</XThemeVoiceAssTableCard>
				);
			case 'loader':
				return <VATimelineLoader analysisId={id} />;
			case 'error':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<p>
								An error occurred while analyzing the case.
								Please try again later.
							</p>
						</div>
					</XThemeVoiceAssTableCard>
				);
			default:
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<Skeleton active paragraph={{ rows: 6 }} />
						</div>
					</XThemeVoiceAssTableCard>
				);
		}
	};

	return <>{renderComponent()}</>;
};

const mapStateToProps = (state) => ({
	editCaseState: state.editCase,
	getAnalysisState: state.getAnalysis,
	getAnalysisStatusState: state.getAnalysisStatus,
});

const mapDispatchToProps = (dispatch) => ({
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: () => dispatch(getAnalysisReset()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(VACaseTimelineController);
